export default "__VITE_ASSET__ee2449ad__"